import { VisualLine } from 'modules/Documents/models/document';

export const processVisualLines = (visualLines: VisualLine[]) => {
  return visualLines.map((visualLine) => ({
    ...visualLine,
    order: visualLine.order,
  }));
};
